export default __webpack_public_path__ + "static/media/ISL.a817dfb3.svg";